
class PageBuilder {

    constructor(params = {}) {

        this.elementSelector = params.element;
        this.element = $(params.element);

        this.languages = this.element.data('languages').split(',');

        this.tab = this.element.find('.builder-tab');
        this.editor = false;

        this.init();

        this.events();

    }

    init() {
        this.createBuilder();
    }

    events() {

        let self = this;

        this.element.find('.btn-build').on('click', function() {
            self.showBuilder();
        });

        $(document).on('click', '.builder-tab .btn-close', function() {
            self.hideBuilder();
        });


        $(document).find('.builder-tab .btn-row-add .dropdown-item').on('click', function() {
            console.log('ddd'+$(this).data('columns'));
            self.addRow($(this).data('columns'));
        });

        $(document).on('click', '.layout-row .btn-content-add', function() {

            let html = $(self.element.find('.template-content-picker').html()),
                guid = $(this).closest('.column').data('guid');

            self.setAttribute(html.find('.content-types'), 'row-guid', guid);

            new Modal({
                "title": 'Column Content',
                "content": html,
                "buttons": [
                    '<button type="button" class="btn btn-danger btn-pagebuilder-modal-cancel">Cancel</button>'
                ]
            });
        });

        $(document).on('click', '.modal .content-type', function() {

            self.addContent(
                $(this).closest('.content-types').data('row-guid'),
                $(this).data('type')
            );

            $('.modal').modal('hide');
        });

        
    }

    addContent(rowGUID, dataType) {

        let column = this.editor.find('.column[data-guid='+rowGUID+']'),
            html = $(this.element.find('.content-templates .content-type-'+dataType).html());

        column.find('> div').html(html);

        if (dataType == 'text') {
 


            tinymce.init({
                target: document.querySelector('#builder-tab-iframe').contentWindow.document.querySelector('.layout-row .column:first-child'),
                content_window: document.querySelector('#builder-tab-iframe').contentWindow,
                content_document: document.querySelector('#builder-tab-iframe').contentDocument,
                menubar: false,
                inline: true,
                plugins: [
                    'autolink',
                    'codesample',
                    'link',
                    'lists',
                    'media',
             //       'powerpaste',
                    'table',
                    'image',
                    'quickbars',
                    'codesample',
                    'help'
                ],
                toolbar: false,
                quickbars_insert_toolbar: 'quicktable image media codesample',
                quickbars_selection_toolbar: 'bold italic underline | formatselect | blockquote quicklink',
                contextmenu: 'undo redo | inserttable | cell row column deletetable | help',
                powerpaste_word_import: 'clean',
                powerpaste_html_import: 'clean'
            });

         
        }
    }

    addRow(columns) {

        let self = this,
            html,
            colWidth;

        html = $(this.element.find('.template-layout-picker .layout[data-columns='+columns+']')[0].outerHTML);

        colWidth = this.getColWidth(columns); 

        let left = 0;

        html.find('.column').each(function() {
            
            self.setAttribute($(this), 'guid', self.uuid());
            self.setAttribute($(this), 'col', 12 / 3);
            self.setAttribute($(this), 'col-start', left / colWidth);
            $(this).css('width', colWidth * (12 / 3));
            $(this).css('left', left);
            left += colWidth * (12 / 3);
  
            if ($(this).next().hasClass('devider')) {
                $(this).next().css('left', left - 5);
            }
        });

        self.editor.append(html[0].outerHTML);        
        
        self.editor.find('.devider').draggable({
            axis: 'x',
            containment: 'parent',
            grid: [colWidth, colWidth],
            drag: function(event, ui) {
   
                let colWidth = self.getColWidth(),
                    prev = ui.helper.prev(),
                    next = ui.helper.next(),
                    colPos = ((ui.position.left + 5) / colWidth) - prev.data('col-start'),
                    max = (prev.data('col') + next.data('col')) - 2;
       
                if (colPos < 2) {
                    ui.position.left = ((prev.data('col-start') + 2) * colWidth) - 5;
                    colPos = 2;
                } 
                else if (colPos > max) {
                    ui.position.left = ((prev.data('col-start') + max) * colWidth) - 5;
                    colPos = max;
                }

                prev.css('width', colPos * colWidth);
                next.css('left', ui.position.left + 5);
                next.css('width', ((prev.data('col') + next.data('col')) - colPos) * colWidth);          
            },
            stop: function(event, ui) {

                let colWidth = self.getColWidth(),
                    colPos = (ui.position.left + 5) / colWidth,
                    prev = ui.helper.prev(),
                    next = ui.helper.next();

                self.setAttribute(prev, 'col', colPos - prev.data('col-start'));
                self.setAttribute(next, 'col', next.width() / colWidth);
                self.setAttribute(next, 'col-start', colPos);
            }
        });

        self.editor.find('.layout-row .btn-content-add').on('click', function() {

            let html = $(self.element.find('.template-content-picker').html()),
            guid = $(this).closest('.column').data('guid');

            self.setAttribute(html.find('.content-types'), 'row-guid', guid);

            new Modal({
                "title": 'Column Content',
                "content": html,
                "buttons": [
                    '<button type="button" class="btn btn-danger btn-pagebuilder-modal-cancel">Cancel</button>'
                ]
            });

        });
    
    }

    createBuilder() {

        let self = this,
            selected = this.getCookie('builder'),
            size;

        if (selected == '') {
            selected = 'desktop';
        }

        size = this.getDeviceWidth(selected);
        size += Math.round((size / 100) * 10);

        this.tab.find('.device').removeClass('selected');   
        this.tab.find('.device[data-type='+selected+']').addClass('selected'); 
        this.tab.find('#builder-tab-iframe').css('width', size+"px");   

        this.tab.find('#builder-tab-iframe').on('load', function() {  
            setLoading('.case', 'remove');   
            self.editor = self.tab.find('#builder-tab-iframe').contents().find('#page .editor');
            self.element.find('.toolbar').removeClass('d-none');
        });
    }

    showBuilder() {
        $('body').css('overflow', 'hidden');
        this.tab.removeClass('closed');
    }

    hideBuilder() {
        this.tab.addClass('closed');
        setTimeout(function() {
            $('body').css('overflow', 'auto');
        }, 750);
    }

    getDeviceWidth(device = false) {

        let selected = device,
            size;

        if (selected === false) {
            selected = $('.builder-tab .device.selected').data('type');
        }

        if (selected == 'desktop') {
            size = 1200;
        }
        if (selected == 'laptop') {
            size = 992;
        }
        if (selected == 'tablet') {
            size = 768;
        }
        if (selected == 'mobile') {
            size = 576;
        }
        if (selected == 'mobile-small') {
            size = 450;
        }

        return size;
    }

    setAttribute(element, attribute, value) {
        element.data(attribute, value);
        element.attr('data-'+attribute, value);
    }

    getRowWidth() {
        return this.editor.width();
    }

    getColWidth(columns) {   
        return this.getRowWidth() / 12;
    }

    uuid() {
        return 'xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 10 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    setCookie(cname, cvalue, exdays = 100) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
}



  // let params,
            //     html;

            // html = $(self.element.find('.template-layout-picker').html());

            // params = {
            //     "title": 'Row Layout',
            //     "content": html,
            //     "buttons": [
            //         '<button type="button" class="btn btn-danger btn-pagebuilder-modal-cancel">Cancel</button>'
            //     ]
            // };

            // new Modal(params);
        // $(document).on('click', '.modal .btn-pagebuilder-modal-cancel', function() {
        //     $('.modal').modal('hide');
        // });

        // $(document).on('click', '.modal .layout', function() {

        //     self.addRow($(this).data('columns'));

        //     $('.modal').modal('hide');
        // });